module.exports = ".video-block{\r\n  width: 60%;\r\n  margin-right:5%;\r\n}\r\n.overview-block{\r\n  width: 35%\r\n}\r\n.dashboard-content{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  width:100%;\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = ./src/app/dashboard/dashboard.component.css
// module chunks = main